import {DataFetcher} from '@aboutyou/data-fetcher';
import React, {FC} from 'react';
import {AppInstallTeaserDesktopView} from './AppInstallTeaserDesktopView';

import {useAppInstallTeaserData} from '../hooks/useAppInstallTeaserData';

export const AppInstallTeaserDesktop: FC<{
  title: string;
  subTitle: string;
  onCancel: () => void;
  onInputTouched?: () => void;
}> = props => {
  return (
    <DataFetcher
      request={useAppInstallTeaserData()}
      Error={null}
      viewProps={props}
      View={AppInstallTeaserDesktopView}
    />
  );
};
